module.exports = __webpack_public_path__ + "img/INF-A-3-III.7977eb99.png";